import React from 'react';
import {
  Link
} from "react-router-dom";
import '../App.css';
import logo from '../assets/unicorn-logo-06.png'
import  {BsBoxArrowUpRight} from 'react-icons/bs'
import { slide as Menu } from 'react-burger-menu'


function NavBar() {
// needs a media query to make sure it condenses appropriately.
    return (
        <div>
        <div className="nav-bar-wrapper">
            <Link to="/" className="nav-link-home">
                <img src={logo} alt="" width="50 rem" style={{verticalAlign:'middle', marginRight:'1rem'}}/>
                
                Health Engine
            </Link>
        
        <div className="nav-bar-container">
            <Link to="/program" className="nav-bar-link">Program</Link>
            <Link to="/portfolio" className="nav-bar-link">Portfolio</Link>
            <Link to="/about" className="nav-bar-link">About</Link>
            <Link to="/jobs" className='nav-bar-link'>Jobs</Link>
            {/* <a href="https://hopin.com/events/fall-2021-cohort-demo-day" className="nav-bar-link-long" style={{textDecoration:''}} target="_blank"> Attend Demo Day I <BsBoxArrowUpRight/> </a> */}
            {/* <a href="https://form.typeform.com/to/berj6VBd" className="nav-bar-link-long" style={{textDecoration:''}} target="_blank"> Apply to Join Cohort II <BsBoxArrowUpRight/> </a> */}
        </div>

        </div>
        <div className="burger-menu"> 
        <Menu>
            <Link to="/" className="nav-bar-link">Home</Link>
            <Link to="/program" className="nav-bar-link">Program</Link>
            <Link to="/portfolio" className="nav-bar-link">Portfolio</Link>
            <Link to="/about" className="nav-bar-link">About</Link>
            <Link to="/jobs" className='nav-bar-link'>Jobs</Link>
            {/* <a href="https://hopin.com/events/fall-2021-cohort-demo-day" className="nav-bar-link-long" style={{textDecoration:''}} target="_blank"> Attend Demo Day I <BsBoxArrowUpRight/> </a> */}
            {/* <a href="https://form.typeform.com/to/berj6VBd" className="nav-bar-link-long" style={{textDecoration:''}} target="_blank"> Apply to Join Cohort II <BsBoxArrowUpRight/> </a> */}
        </Menu>
        </div>

        </div>

        
    ); 
} export default NavBar;